import React, { useState, useMemo } from "react";
import { useLocation } from "react-router";
import styles from "./styles.css";
import { Heading } from "@cars24/turbo-web/lib/heading";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import { Text } from "@cars24/turbo-web/lib/text";
import rightArrow from "./images/rightArrow.svg";
import LazyImage from "../../shared/lazy-image";
import { NUMBER } from "../../../constants/app-constants";
import { LinkButton } from "@cars24/turbo-web/lib/link-button";
import { ArrowIcon } from "@cars24/turbo-web/lib/icons/arrow-icon";
import PropTypes from "prop-types";
import { appUrl } from "../../../constants/url-constants";

const PreDeliveryInspectionCities = ({ details }) => {
    const { tokens } = useTokens();
    const { pathname } = useLocation();

    const { title = "", sectionData = [] } = details || {};

    const [showAll, setShowAll] = useState(false);

    const currentCityMatch =
    pathname && pathname.match(/\/pre-delivery-inspection-([^/]+)/);
    const currentCitySlug = currentCityMatch
        ? currentCityMatch[1]?.toLowerCase()
        : null;

    const filteredCities = useMemo(
        () =>
            Array.isArray(sectionData)
                ? sectionData.filter(
                    city =>
                        (city?.subTitle || "").toLowerCase() !== (currentCitySlug || "")
                )
                : [],
        [currentCitySlug, sectionData]
    );

    const visibleCities = useMemo(
        () => (showAll ? filteredCities : filteredCities?.slice(0, NUMBER.EIGHT)),
        [showAll, filteredCities]
    );

    if (sectionData?.length === 0) {
        return null;
    }

    return (
        <div styleName={"styles.citiesWrapper"}>
            <Heading level={2} color={tokens.text_default_text_primary}>
                {title}
            </Heading>
            <div styleName={"styles.citiesGrid"}>
                {visibleCities.map((item, index) => (
                    <a
                        key={index}
                        styleName={"styles.cityWrapper"}
                        href={`${appUrl()}/pre-delivery-inspection-${item?.subTitle}/`}
                    >
                        <Text
                            size={200}
                            fontWeight="medium"
                            color={tokens.text_default_text_primary}
                        >
                            {item?.title}
                        </Text>
                        <LazyImage src={rightArrow} alt="right arrow" />
                    </a>
                ))}
            </div>
            {sectionData?.length > NUMBER.EIGHT ? <div styleName={"styles.buttonWrapper"}>
                <LinkButton
                    label={showAll ? "Show Less" : "Show More"}
                    onClick={() => setShowAll(!showAll)}
                    variant="brand"
                    preventDefaultBehaviour
                    suffixIcon={
                        <ArrowIcon
                            rotateBy={showAll ? NUMBER.MINUS_NINETY : NUMBER.NINETY}
                        />
                    }
                />
            </div> : null}
        </div>
    );
};

PreDeliveryInspectionCities.propTypes = {
    details: PropTypes.object
};

export default PreDeliveryInspectionCities;
